export const UI_TEXT = {
  common: {
    appName: "Darts Life",
    loading: "読み込み中...",
  },
  nav: {
    home: "ホーム",
    tournaments: "トーナメント",
    ranking: "ランキング",
    profile: "マイページ",
  },
  auth: {
    signIn: {
      welcome: "おかえりなさい",
      loginIdLabel: "ログインID",
      loginIdPlaceholder: "例: yamada_taro",
      passwordLabel: "パスワード",
      passwordPlaceholder: "••••••••",
      submit: "ログイン",
      noAccount: "アカウントをお持ちでない方",
      toSignUp: "新規アカウント作成",
    },
    signUp: {
      title: "新規アカウント作成",
      loginIdLabel: "ログインID",
      loginIdPlaceholder: "例: yamada_taro",
      passwordLabel: "パスワード",
      passwordPlaceholder: "••••••••",
      dartsLiveCardLabel: "DARTSLIVEカード名",
      dartsLiveCardPlaceholder: "カード名（任意）",
      submit: "アカウント作成",
      toSignIn: "すでにアカウントをお持ちの方はログイン",
    },
  },
  dashboard: {
    upNext: "次のイベント",
    schedule: "スケジュール",
    pastEvents: "過去イベント",
  },
  tournaments: {
    tournamentCreationNotice: "トーナメント表はイベント前日の18:00頃に自動作成されます",
  },
  profile: {
    title: "マイページ",
    logout: "ログアウト",
    matchHistory: "試合履歴",
  },
  eventCard: {
    status: {
      finished: "イベント終了",
      inProgress: "募集終了",
      entered: "参加済み",
      open: "募集中",
    },
    exciting: "Exciting Stage 1.5倍",
    participantUnit: "人",
  },
  eventDetail: {
    close: "閉じる",
    labels: {
      date: "開催日時",
      location: "会場",
      format: "試合フォーマット",
      formatPrefix: "マッチ形式",
      fee: "参加費",
      notes: "その他",
      participants: "参加者一覧",
      participantName: "名前",
      noParticipants: "参加者はいません",
      participantUnit: "名",
      ranking: "順位",
      points: "ポイント",
      rankPointSuffix: "pt",
    },
    format: {
      singles: "シングルス",
      doubles: "ダブルス",
      exciting: "エキサイティング 1.5倍",
    },
    ranking: {
      singlesTitle: "シングルス 獲得ポイント一覧",
      doublesTitle: "ダブルス 獲得ポイント一覧",
      description: "このイベントで順位ごとに獲得できるポイントです。",
    },
    actions: {
      showResult: "イベント結果を見る",
      entryClosed: "募集終了",
      entered: "参加済み",
      cancelEntry: "参加をキャンセル",
      enter: "参加する",
      startTournament: "イベント開始",
      endEvent: "イベント終了",
      edit: "編集",
      delete: "削除",
    },
    finished: "このイベントは終了しました",
    confirmEnd: {
      title: "イベントを終了しますか？",
      description: "この操作は取り消せません。",
      cancel: "キャンセル",
      confirm: "OK",
    },
  },
  eventForm: {
    loadEventGroupsError: "イベント一覧の取得に失敗しました。",
    noEventGroups: "イベントがありません",
    titleEdit: "イベント編集",
    titleCreate: "イベント作成",
    labels: {
      tournament: "イベント",
      eventName: "イベント名（ステージ）",
      date: "開催日時",
      location: "会場",
      matchFormat: "マッチ形式",
      singles: "シングルス",
      fee: "参加費",
      hasPoints: "ポイント付与あり",
      exciting: "エキサイティングステージ（Pt1.5倍）",
      notes: "その他",
    },
    placeholders: {
      eventName: "例: Stage999",
      matchFormat: "例: 501-501-501\nCricket\nChoice",
      notes: "備考など",
    },
    submit: "登録",
  },
} as const;
